const MySmartwayView = () =>  import('./MySmartwayViews/App.vue') ;

import Vue from 'vue';
import authService from '@/services/mySmartway/auth/Auth';
import axios from 'axios';

function MySmartway() {
  authService.init({ onLoad: 'login-required'}).then((isAuth: boolean) => {
    if (isAuth) {
      return new Vue({
        el: '#app',
          render: (element) => element(MySmartwayView, { props: { authService, axios } }),
        });
    } else {
      window.location.reload();
    }
    setInterval(() => { authService.updateToken(70); }, 6000);
    });

}

export default MySmartway;
